export var Role;
(function (Role) {
    Role["ADMIN"] = "admin";
    Role["PROGRAMME_MANAGER"] = "programme_manager";
    Role["REPORT"] = "report";
    Role["GUEST"] = "guest";
})(Role || (Role = {}));
